module.exports = __webpack_public_path__ + "img/cryo-hero.3cb5886f.png";